// Single config object that reads from environment variables
const config = {
    ga_4: process.env.REACT_APP_GA_4 || "G-JBLW3M5JP7",
    ga: process.env.REACT_APP_GA || "",
    url: process.env.REACT_APP_URL || "http://localhost:4200/",
    app_name: process.env.REACT_APP_NAME || "ONEPROFILE",
    authen: {
        sso_url: process.env.REACT_APP_SSO_URL || "https://d2zjecrqpgwbzj.cloudfront.net",
        client_id: process.env.REACT_APP_CLIENT_ID || "ONEPROFILE",
        redirect_uri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:4200/checking",
        grant_type: process.env.REACT_APP_GRANT_TYPE || "authorization_code",
        length: parseInt(process.env.REACT_APP_AUTH_LENGTH || "32"),
        api: {
            host_url: process.env.REACT_APP_AUTH_API_HOST_URL || "https://mysatest.scoutout.net",
            token: process.env.REACT_APP_AUTH_API_TOKEN || "/api/v2.0/oauth/token",
            profile: process.env.REACT_APP_AUTH_API_PROFILE || "/api/v2.0/manager/profile",
            refresh_token: process.env.REACT_APP_AUTH_API_REFRESH_TOKEN || "/api/v2.0/oauth/token"
        },
        rama: {
            host_url: process.env.REACT_APP_RAMA_HOST_URL || "https://ramatest.scoutout.net"
        }
    },
    leela: {
        host_url: process.env.REACT_APP_LEELA_HOST_URL || "https://leeladev.scoutout.net/api/v1/"
    },
    resume_builder: {
        upload_resume: {
            x_api_key: process.env.REACT_APP_RESUME_X_API_KEY,
            base_url: process.env.REACT_APP_RESUME_URL,
            type: process.env.REACT_APP_RESUME_BUILDER_TYPE || "one_profile"
        }
    },
    chat_gpt: {
        base_url: process.env.REACT_APP_CHAT_GPT_URL,
        x_api_key: process.env.REACT_APP_CHAT_GPT_X_API_KEY
    },
    iframe: {
        interivew_ai: process.env.REACT_APP_IFRAME_INTERVIEW_AI || "https://interview-question-test.web.app",
        personality_test: process.env.REACT_APP_IFRAME_PERSONALITY_TEST || "https://scoutout-personality-test.web.app"
    },
    career_site: {
        base_url: process.env.REACT_APP_CAREER_SITE_BASE_URL || ".devphaona.scoutout.xyz",
    },
    personality_api: {
        base_url: process.env.REACT_APP_PERSONALITY_URL,
        x_api_key_quiz: process.env.REACT_APP_PERSONALITY_X_API_KEY,
    },
    view_resume: {
        base_url: process.env.REACT_APP_VIEW_RESUME_URL,
        x_api_key: process.env.REACT_APP_VIEW_RESUME_X_API_KEY,
    },
    career_craft: {
        base_url: process.env.REACT_APP_CAREER_CRAFT_BASE_URL || "https://ramadev.scoutout.net/api"
    },
    resume_checker: {
        x_api_key: process.env.REACT_APP_RESUME_X_API_KEY,
        main: process.env.REACT_APP_RESUME_CHECKER_MAIN || "https://resume-checker-test.web.app"
    },
    salary_checker: {
        url: process.env.REACT_APP_SALARY_CHECKER_URL || "https://salary.scoutout.co?utm_source=ONEPROFILE"
    },
    jobboard: {
        url: process.env.REACT_APP_JOBBOARD_URL || "https://d2mkkyov94e9cz.cloudfront.net"
    },
    functions: {
        base_url: process.env.REACT_APP_ONE_PROFILE_FUNCTIONS_URL || ""
    }
};

export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 10,
    MAX_ATTACHMENT_RESUME_IMAGE_SIZE: 1,
    ...config
};
